module.exports = __webpack_public_path__ + "10_hair_black.03a9e293.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/10_hair_black.png
// module id = v2Kb
// module chunks = 0